<template>
  <el-table-column prop="email" label="Email" header-align="center" width="200">
    <template #default="scope">
      <div :title="scope.row.email">
        {{ truncateText(scope.row.email, 18) }}
      </div>
    </template>
  </el-table-column>
</template>

<script setup>
const truncateText = (text, maxLength) => {
  if (!text) return "";
  if (text.length > maxLength) {
    return `${text.substring(0, maxLength)}...`;
  }
  return text;
};
</script>
